import './App.css';
import LoginComponent from './components/login/Login';
import ErrorComponent from './components/error/error'; 
import DashboardComponent from './components/dashboard/dashboard'; 
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import AuthProvider, { useAuth } from './components/http/authcontex';
import '@mdi/font/css/materialdesignicons.css';
import ShowEmployee from './components/employee/ShowEmployee';
import EditEmployee from './components/employee/EditEmployee';
import EditEmployeeOpen from './components/employee/EditEmployeeOpen';
import Report from './components/report/Report';

function RoutAuth({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/" />;
}

function App() {
  return (
    <AuthProvider> 
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/" element={<LoginComponent />} />
            <Route 
              path="/dashboard" 
              element={
                <RoutAuth>
                  <DashboardComponent />
                </RoutAuth>
              } 
            />
            <Route path="/employee" element={
                <RoutAuth>
                  <ShowEmployee/>
                </RoutAuth>
              } 
            />

            <Route path="/editEmployee" element={
                <RoutAuth>
                  <EditEmployee/>
                </RoutAuth>
              } 
            />

              <Route path="/report" element={
                <RoutAuth>
                  <Report/>
                </RoutAuth>
              } 
            />

             <Route path="/editEmployee/open" element={
                <EditEmployeeOpen/>
              } 
            />

            <Route path="*" element={<ErrorComponent />} />           
          </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
